<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M9.5 6.5C8 8 7 10 7 12c0 4.5 3.5 8 8 8 2 0 4-1 5.5-2.5 2.5-2.5 3-7.5-1-11.5-4-4-9-3.5-11.5-1C6.5 6.5 5.5 8 5 10" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 19L7 15" />
    <ellipse cx="15" cy="12" rx="4" ry="5" stroke-width="1.5" />
  </svg>
</template>
